import { fmt } from 'IntlWrapper/IntlWrapper';

import { ReactComponent as Deliver } from 'assets/bosta-icons/Out for Delivery.svg';
import { ReactComponent as Return } from 'assets/bosta-icons/Return.svg';
import { ReactComponent as Exchange } from 'assets/bosta-icons/Exchange.svg';
import { ReactComponent as PickUp } from 'assets/bosta-icons/Pickups.svg';
import { ReactComponent as SignAndReturn } from 'assets/bosta-icons/sign-and-return.svg';
import { ReactComponent as CashCollection } from 'assets/bosta-icons/Cash Collection.svg';

export const RTO_TYPE = 'RTO';
export const ROUTES_STATE = {
  DRAFTED: 0,
  DISPATCHED: 1,
  DEBRIEFED: 2,
  DONE: 3,
  ARCHIVED: 4,
  UNASSIGNED: 5,
  ASSIGNED: 6,
  ACCEPTED: 7,
  REJECTED: 8
};

export const DROP_OFF = 'DROP_OFF';
export const PICK_UP = 'PICK_UP';
export const RTO_GROUP = 'RTO_GROUP';
export const VRET_GROUP = 'VRET_GROUP';
export const DATE_FORMAT = 'DD MMM YYYY';

export const OTP = 'OTP';
export const SIGNATURE = 'signature';

export const UNASSIGNED = 'UnAssigned';

export const DYNAMIC_ROUTES_STATES = {
  Drafted: {
    STATE_NAME: 'Drafted',
    COLOR: '#FF0000'
  },
  Created: {
    STATE_NAME: 'Created',
    COLOR: '#008000'
  },
  Merged: {
    STATE_NAME: 'Merged',
    COLOR: '#FF0000'
  }
};

export const DEFAULT_CLUSTER_COLOR = '#FF0000';

export const RETURN_GROUPS_STATE = {
  REJECTED: fmt({ id: 'return_manifest.return_group_states.rejected' }),
  PARTIALLY_RETURNED: fmt({
    id: 'return_manifest.return_group_states.partially_returned'
  }),
  EXCEPTION: fmt({
    id: 'deliveries.states.exception'
  }),
  RETURNED: fmt({
    id: 'deliveries.states.returned'
  }),
  OUT_FOR_RETURN: fmt({
    id: 'deliveries.states.out_for_return'
  })
};

export const RETURN_GROUPS_STATE_COLORS = {
  REJECTED: 'br-state-red-group',
  PARTIALLY_RETURNED: 'br-state-green-group',
  EXCEPTION: 'br-state-red-group',
  RETURNED: 'br-state-green-group',
  OUT_FOR_RETURN: 'br-state-yellow-group'
};

export const ROUTE_STATES_LABEL = {
  DRAFTED: 'Drafted',
  DISPATCHED: 'Dispatched',
  DEBRIEFED: 'Debriefed',
  DONE: 'Done',
  ARCHIVED: 'Archived',
  UNASSIGNED: 'UnAssigned',
  ASSIGNED: 'Assigned',
  ACCEPTED: 'Accepted',
  REJECTED: 'Rejected'
};

export const ROUTE_STATES_TAG_COLOR = {
  [ROUTE_STATES_LABEL.DRAFTED]: 'yellow',
  [ROUTE_STATES_LABEL.DISPATCHED]: 'purple',
  [ROUTE_STATES_LABEL.DEBRIEFED]: 'gray',
  [ROUTE_STATES_LABEL.DONE]: 'green',
  [ROUTE_STATES_LABEL.ARCHIVED]: 'gray',
  [ROUTE_STATES_LABEL.UNASSIGNED]: 'teal',
  [ROUTE_STATES_LABEL.ASSIGNED]: 'blue',
  [ROUTE_STATES_LABEL.ACCEPTED]: 'gray',
  [ROUTE_STATES_LABEL.REJECTED]: 'gray'
};

export const ROUTES_STATES = [
  {
    label: fmt({ id: 'routes.routes_listing.route_states.drafted' }),
    value: 0
  },
  {
    label: fmt({ id: 'routes.routes_listing.route_states.dispatched' }),
    value: 1
  },
  {
    label: fmt({ id: 'routes.routes_listing.route_states.debriefed' }),
    value: 2
  },
  {
    label: fmt({ id: 'routes.routes_listing.route_states.done' }),
    value: 3
  },
  {
    label: fmt({ id: 'routes.routes_listing.route_states.archived' }),
    value: 4
  },
  {
    label: fmt({ id: 'routes.routes_listing.route_states.unassigned' }),
    value: 5
  },
  {
    label: fmt({ id: 'routes.routes_listing.route_states.assigned' }),
    value: 6
  },
  {
    label: fmt({ id: 'routes.routes_listing.route_states.accepted' }),
    value: 7
  },
  {
    label: fmt({ id: 'routes.routes_listing.route_states.rejected' }),
    value: 8
  }
];

export const MOVE_TO_ROUTE_COLUMNS = [
  {
    dataIndex: 'name',
    title: fmt({ id: 'routes.routes_listing.table_columns.name' })
  },
  {
    dataIndex: 'star',
    title: fmt({ id: 'routes.routes_listing.table_columns.assigned_star' })
  },
  {
    dataIndex: 'createdAt',
    title: fmt({ id: 'routes.routes_listing.table_columns.created_at' })
  },
  {
    dataIndex: 'numberOfDeliveries',
    title: fmt({
      id: 'routes.routes_listing.table_columns.number_of_deliveries'
    })
  },
  {
    dataIndex: 'numberOfPickups',
    title: fmt({
      id: 'routes.routes_listing.table_columns.number_of_pickups'
    })
  }
];

export const ROUTES_TABLE_COLUMNS = (renderTableActions) => [
  {
    dataIndex: 'name',
    title: fmt({ id: 'routes.routes_listing.table_columns.name' }),
    width: 264
  },

  {
    dataIndex: 'star',
    title: fmt({ id: 'routes.routes_listing.table_columns.assigned_star' }),
    width: 264
  },
  {
    dataIndex: 'createdAt',
    title: fmt({ id: 'routes.routes_listing.table_columns.created_at' }),
    width: 264
  },
  {
    dataIndex: 'numberOfDeliveries',
    title: fmt({
      id: 'routes.routes_listing.table_columns.number_of_deliveries'
    }),
    width: 125
  },
  {
    dataIndex: 'numberOfPickups',
    title: fmt({
      id: 'routes.routes_listing.table_columns.number_of_pickups'
    }),
    width: 125
  },
  {
    dataIndex: 'progress',
    title: fmt({ id: 'routes.routes_listing.table_columns.progress' }),
    width: 170
  },
  {
    dataIndex: '',
    align: 'center',
    width: 80,
    render: (record) => renderTableActions(record)
  }
];

export const QUICK_FILTERS_VALUES = {
  AT_RISK: 'isAtRisk',
  INACTIVE: 'isInactive',
  HIGH_RISK: 'isHighRisk',
  ALL: 0,
  UNASSIGNED: 5,
  ASSIGNED: 6,
  DONE: 3,
  DEBREIFED: 2,
  ARCHIVED: 4
};

export const ROUTES_TABLE_QUICK_FILTERS = ({ selectedHub }) => {
  return [
    {
      label: fmt({
        id: 'routes.routes_listing.quick_filters.all'
      }),
      value: QUICK_FILTERS_VALUES.ALL
    },
    {
      label: fmt({
        id: 'routes.routes_listing.quick_filters.unassigned'
      }),
      value: QUICK_FILTERS_VALUES.UNASSIGNED
    },
    {
      label: fmt({
        id: 'routes.routes_listing.quick_filters.assigned'
      }),
      value: QUICK_FILTERS_VALUES.ASSIGNED
    },
    {
      label: fmt({
        id: 'routes.routes_listing.quick_filters.done'
      }),
      value: QUICK_FILTERS_VALUES.DONE
    },
    {
      label: fmt({
        id: 'routes.routes_listing.quick_filters.debriefed'
      }),
      value: QUICK_FILTERS_VALUES.DEBREIFED
    },
    {
      label: fmt({
        id: 'routes.routes_listing.quick_filters.archived'
      }),
      value: QUICK_FILTERS_VALUES.ARCHIVED
    },
    {
      label: fmt({
        id: 'routes.routes_listing.quick_filters.at_risk'
      }),
      value: QUICK_FILTERS_VALUES.AT_RISK,
      disabled: !selectedHub
    },
    {
      label: fmt({
        id: 'routes.routes_listing.quick_filters.high_risk'
      }),
      value: QUICK_FILTERS_VALUES.HIGH_RISK,
      disabled: !selectedHub
    },
    {
      label: fmt({
        id: 'routes.routes_listing.quick_filters.inactive'
      }),
      value: QUICK_FILTERS_VALUES.INACTIVE,
      disabled: !selectedHub
    }
  ];
};

export const ROUTES_SEARCH_OPTIONS = [
  {
    title: fmt({
      id: 'routes.routes_listing.routes_listing_search_options.route'
    }),
    value: 'name'
  },
  {
    title: fmt({
      id: 'routes.routes_listing.routes_listing_search_options.tracking_number'
    }),
    value: 'trackingNumber'
  },
  {
    title: fmt({
      id: 'routes.routes_listing.routes_listing_search_options.pickup_request_id'
    }),
    value: 'pickupRequestId'
  }
];

export const MOVE_TO_ROUTE_SEARCH_OPTIONS = [
  {
    title: fmt({
      id: 'routes.routes_listing.routes_listing_search_options.star'
    }),
    value: 'starName'
  },
  {
    title: fmt({
      id: 'routes.routes_listing.routes_listing_search_options.route'
    }),
    value: 'name'
  }
];

export const VALIDATION_MODALS_TYPES_COLORS = {
  BLOCKING: 'red',
  WARNING: 'brown',
  SCANNED: 'blue'
};
export const ROUTE_EXPORT_TYPE = 'exportRoutes';

export const POINTS_LISTING_COLUMNS = [
  {
    title: fmt({
      id: 'routes.routes_listing.points_listing_columns.type'
    }),
    dataIndex: 'orderType'
  },
  {
    title: fmt({
      id: 'routes.routes_listing.points_listing_columns.street_code'
    }),
    dataIndex: 'streetCode'
  },
  {
    title: fmt({
      id: 'routes.routes_listing.points_listing_columns.address'
    }),
    dataIndex: 'address'
  },
  { dataIndex: 'actions', width: 70 }
];

export const SCANNING_POINTS_TYPES = {
  CUSTOEMR_RETURN_PICKUP: 'CUSTOMER_RETURN_PICKUP',
  SIGN_AND_RETURN: 'SIGN_AND_RETURN'
};

export const POINTS_LISTING_ICONS_MAPPING = {
  SEND: <Deliver />,
  RTO: <Return />,
  EXCHANGE: <Exchange />,
  PICK_UP: <PickUp />,
  CUSTOMER_RETURN_PICKUP: <Return />,
  SIGN_AND_RETURN: <SignAndReturn />,
  CASH_COLLECTION: <CashCollection />,
  FIRST_MILE_PICKUP: <PickUp />,
  FXF_SEND: <Deliver />
};

export const ROUTES_CREATION_QUICK_FILTERS = (pointTypesCount) => [
  {
    label: (
      <span>
        <span>
          {fmt({ id: 'routes.routes_listing.routes_quick_filters.all' })}
        </span>
        <span className="br-routes-quick-filters__count">
          {pointTypesCount.ALL}
        </span>
      </span>
    ),
    value: 0
  },
  {
    label: (
      <span>
        <span>
          {fmt({ id: 'routes.routes_listing.routes_quick_filters.deliveries' })}
        </span>
        <span className="br-routes-quick-filters__count">
          {pointTypesCount.SEND}
        </span>
      </span>
    ),
    value: 'SEND'
  },
  {
    label: (
      <span>
        <span>
          {fmt({ id: 'routes.routes_listing.routes_quick_filters.pickups' })}
        </span>
        <span className="br-routes-quick-filters__count">
          {pointTypesCount.PICK_UP}
        </span>
      </span>
    ),
    value: 'PICK_UP'
  },
  {
    label: (
      <span>
        <span>
          {' '}
          {fmt({ id: 'routes.routes_listing.routes_quick_filters.rto' })}
        </span>
        <span className="br-routes-quick-filters__count">
          {pointTypesCount.RTO}
        </span>
      </span>
    ),
    value: 'RTO'
  },
  {
    label: (
      <span>
        <span>
          {fmt({ id: 'routes.routes_listing.routes_quick_filters.crp' })}
        </span>
        <span className="br-routes-quick-filters__count">
          {pointTypesCount.CUSTOMER_RETURN_PICKUP}
        </span>
      </span>
    ),
    value: 'CUSTOMER_RETURN_PICKUP'
  }
];

export const DONE = 'Done';

export const DELIVERY = 'delivery';

export const ROUTES_ANALYTICS_CARDS = (analyticsData) => {
  const {
    routesCount,
    unassignedRoutesCount,
    assignedRoutesCount,
    inactiveRoutesCount,
    atRiskRoutesCount,
    highRiskRoutesCount
  } = analyticsData || {};
  return [
    {
      title: fmt({
        id: 'routes.routes_listing.quick_filters.all'
      }),
      data: routesCount
    },
    {
      title: fmt({
        id: 'routes.routes_listing.quick_filters.unassigned'
      }),
      data: unassignedRoutesCount
    },
    {
      title: fmt({
        id: 'routes.routes_listing.anayltics_cards_titles.assigned_not_dispatched'
      }),
      data: assignedRoutesCount
    },
    {
      title: fmt({
        id: 'routes.routes_listing.quick_filters.inactive'
      }),
      data: inactiveRoutesCount
    },
    {
      title: fmt({
        id: 'routes.routes_listing.quick_filters.at_risk'
      }),
      data: atRiskRoutesCount
    },
    {
      title: fmt({
        id: 'routes.routes_listing.anayltics_cards_titles.high_risk'
      }),
      data: highRiskRoutesCount
    }
  ];
};

export const SCHEDULED_FEATURE_TOGGLE = 'validate-delivery-scheduled-at';
